const TrendingSearchData = [
  {
    title: 'Women’s Skinny Jeans',
    url: '/womens-clothing/jeans/skinny-jeans/cat1910079',
    linkId: '01',
    category: 'trending-search',
  },
  {
    title: 'Men’s Jeans',
    url: '/mens-clothing/jeans/cat400003',
    linkId: '02',
    category: 'trending-search',
  },
  {
    title: 'Women’s Essential Tops',
    url: '/womens-clothing/tops/modern-essential-tops/cat4800008',
    linkId: '03',
    category: 'trending-search',
  },
  {
    title: 'Men’s Denim Shirts',
    url: '/mens-clothing/shirts/casual-shirts/denim-shirts/cat2300017',
    linkId: '04',
    category: 'trending-search',
  },
  {
    title: 'Women’s Matching Sets',
    url: '/womens-clothing/whats-hot/two-piece-sets/cat2060022',
    linkId: '05',
    category: 'trending-search',
  },
  {
    title: 'Men’s Tees',
    url: '/mens-clothing/shirts/tees-henleys/cat430030',
    linkId: '06',
    category: 'trending-search',
  },
];

export default TrendingSearchData;
